export enum Apps {
	TherapyEd = "therapyed",
	Psi = "psi",
	Jbjs = "jbjs",
	hiset = "hiset",
	toefl = "toefl",
	faa = "faa",
	cambridge = "cambridge",
	aavsb = "aavsb",
	cmaa = "cmaa",
	nascla = "nascla",
	wocncb = "wocncb",
	wpi = "wpi",
	aapa = "aapa",
	act = "act",
	rockettestprep = "rockettestprep",
	toeic = "toeic",
	naplex = "naplex",
	pte = "pte",
}

export const appWebDomains: Partial<Record<Apps, string>> = {
	[Apps.Psi]: "app.psiexams.com",
	[Apps.TherapyEd]: "app.therapyed.com",
	[Apps.aapa]: "app.aapa.org",
	[Apps.nascla]: "app.nascla.psiexams.com",
	[Apps.wocncb]: "app.wocncb.org",
	[Apps.aavsb]: "app.aavsb.org",
	[Apps.wpi]: "app.gowpi.org",
	[Apps.act]: "app.act.memorang.app",
	[Apps.Jbjs]: "app.jbjs.org",
	[Apps.toefl]: "app.toefl.com",
	[Apps.faa]: "app.aviation.psiexams.com",
	[Apps.rockettestprep]: "app.rockettestprep.memorang.app",
	[Apps.toeic]: "prep.toeiclink.com",
	[Apps.naplex]: "accesspharmacy.mh.memorang.com",
	[Apps.pte]: "app.practice.pearsonpte.com",
	[Apps.cmaa]: "app.cmaanet.org",
	[Apps.cambridge]: "app.englishhub.cambridge.org",
};

export type AppIds =
	| "com.memorang.therapyed"
	| "com.memorang.psi.insurance"
	| "com.memorang.psi.insurance.testprep"
	| "org.ets.toeflpracticeaicoach"
	| "com.memorang.jbjs.image.challenge"
	| "com.memorang.jbjs.app"
	| "com.memorang.jbjs"
	| "com.memorang.psi.aviation"
	| "com.memorang.cambridge.cupa.ema"
	| "com.memorang.aavsb"
	| "com.memorang.psi.cmaa"
	| "com.memorang.nascla"
	| "com.memorang.psi.wocncb.testprep"
	| "com.memorang.psi.wocncb"
	| "com.memorang.psi.wpi"
	| "com.memorang.aapa"
	| "com.memorang.act.testprep"
	| "com.memorang.acme.rockettestprep"
	| "org.ets.toeic-link-prep"
	| "com.memorang.pearson.pte"
	| "org.ets.toeic_link_prep";

export type AppContextCache = {
	selectedStates: [
		{
			code: string;
			relatedExamsIds: string[];
		},
	];
};
